function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FlashMessages from 'shared/components/FlashMessages';
import { T } from 'shared/helper/translate';
import GlobalLoading from 'researcher/components/GlobalLoading';
import { recordUrl } from 'researcher/helpers/gtm';
import { getChinaLocalization } from 'shared/account/reducer';
import SubNavigation from './SubNavigation';
import Banners from './Banners';
var CommonLayout = function CommonLayout(_ref) {
  var dismissMessage = _ref.dismissMessage,
    displayOrderFormBanner = _ref.displayOrderFormBanner,
    displayCheckSpamMessagesBanner = _ref.displayCheckSpamMessagesBanner,
    displayDashboardBanner = _ref.displayDashboardBanner,
    heading = _ref.heading,
    hideCheckSpamMessageBanner = _ref.hideCheckSpamMessageBanner,
    isOrderFormProcess = _ref.isOrderFormProcess,
    isCurieRoute = _ref.isCurieRoute,
    isHomeRoute = _ref.isHomeRoute,
    location = _ref.location,
    subnavItems = _ref.subnavItems,
    updatingTranslations = _ref.updatingTranslations,
    user = _ref.user;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentPath = _useState2[0],
    setCurrentPath = _useState2[1];
  var _useSelector = useSelector(function (state) {
      return state.application.config;
    }),
    consentBundle = _useSelector.consentBundle;
  var chinaLocalization = useSelector(getChinaLocalization);
  useEffect(function () {
    if (!chinaLocalization) {
      var _ref2 = consentBundle || {},
        attributes = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
      var script = document.createElement('script');
      Object.entries(attributes).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        if (key === 'data') {
          Object.entries(value).forEach(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
              dataKey = _ref6[0],
              dataValue = _ref6[1];
            script.dataset[dataKey] = dataValue;
          });
        } else {
          script.setAttribute(key, value);
        }
      });
      document.head.appendChild(script);
    }
  }, []);
  useEffect(function () {
    if (currentPath !== location.pathname) {
      recordUrl(location.pathname);
      setCurrentPath(location.pathname);
    }
  }, [location]);
  useEffect(function () {
    // remove the cookie bot's sideeffect which removes padding-top from the body
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          observer.disconnect();
          document.body.style.paddingTop = '';
        }
      });
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style']
    });
    return function () {
      observer.disconnect();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", null, updatingTranslations ? /*#__PURE__*/React.createElement(GlobalLoading, null) : null, /*#__PURE__*/React.createElement(Banners, {
    displayOrderFormBanner: displayOrderFormBanner,
    displayDashboardBanner: displayDashboardBanner,
    displayCheckSpamMessagesBanner: displayCheckSpamMessagesBanner,
    hideCheckSpamMessageBanner: hideCheckSpamMessageBanner,
    user: user
  }), user && user.loggedIn && !isOrderFormProcess && !isCurieRoute && !isHomeRoute ? /*#__PURE__*/React.createElement(SubNavigation, {
    items: subnavItems,
    user: user
  }) : null, heading ? /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto page-heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(T, {
    source: heading
  }))))) : null, /*#__PURE__*/React.createElement(FlashMessages, {
    dismissMessage: dismissMessage
  }));
};
export default CommonLayout;